import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Dashboard from './pages/Dashboard/Dashboard';
import Profile from './pages/Profile/Profile';
import TokensList from './pages/Tokens/TokensList';
import ProxiesList from './pages/Proxies/ProxiesList';
import Connections from './pages/Connections/Connections';
import Sessions from './pages/Sessions/Sessions';
import OAuthCallback from './pages/OAuthCallback/OAuthCallback';
import LoadingSpinner from './components/common/LoadingSpinner';

// Защищённый маршрут
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Публичный маршрут (перенаправляет на дашборд если авторизован)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Главный компонент приложения
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                style: {
                  background: '#10B981',
                },
              },
              error: {
                style: {
                  background: '#EF4444',
                },
              },
            }}
          />
          
          <Routes>
            {/* Публичные маршруты */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />
            
            {/* OAuth callback - специальный маршрут без проверки авторизации */}
            <Route path="/auth/callback" element={<OAuthCallback />} />
            
            {/* Защищённые маршруты */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="tokens" element={<TokensList />} />
              <Route path="proxies" element={<ProxiesList />} />
              <Route path="connections" element={<Connections />} />
              <Route path="sessions" element={<Sessions />} />
              <Route path="profile" element={<Profile />} />
            </Route>
            
            {/* 404 - перенаправление на дашборд */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
